var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEarth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 25.6667C20.4432 25.6667 25.6666 20.4433 25.6666 14C25.6666 7.55667 20.4432 2.33333 13.9999 2.33333C7.5566 2.33333 2.33325 7.55667 2.33325 14C2.33325 20.4433 7.5566 25.6667 13.9999 25.6667Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.49562C7.91028 6.32456 9.78547 8.59036 10.0039 11.0219C10.2081 13.2948 11.7083 15.1417 14 15.1667C14.8807 15.1762 15.7714 14.5401 15.7691 13.6593C15.7684 13.3869 15.7235 13.1084 15.6532 12.8524C15.5553 12.4959 15.5466 12.0861 15.75 11.6667C16.4615 10.1996 17.861 9.80557 18.9699 9.00884C19.4616 8.65548 19.9102 8.28272 20.1081 7.98247C20.6543 7.15352 21.2004 5.49562 20.9273 4.66667",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6667 15.1667C25.2824 16.2528 25.0105 19.1042 20.6713 19.1494C20.6713 19.1494 16.8288 19.1494 15.676 21.3219C14.7537 23.0598 15.2917 24.9425 15.676 25.6667",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarth);
export default __webpack_public_path__ + "static/media/earth.5dd367c158b47342fcf7800169f20f07.svg";
export { ForwardRef as ReactComponent };